import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import QRCodePage from './pages/QRCodePage';
import DashboardPage from './pages/DashboardPage';

const NotFoundPage = () => (
  <div className="container mt-5 text-center">
    <h2>404 - Page Not Found</h2>
    <p>The page you are looking for does not exist.</p>
  </div>
);

function App() {
  return (
    <Router>
      <Routes>
        {/* <Route path="/" element={<QRCodePage />} /> */}
        <Route path="/" element={<DashboardPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
}

export default App;